import { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router";
import { parameterSetConfig as defaultConfig } from "./ParametreSet";
import axiosBase from "../common/axiosBase";
import coreConfig from "../common/coreConfig";
import CommonUiModel from "../common/commonUiModel";
import { logger } from "../App";

const { apiConfig, hookupConfig, equipmentIdMapper } = coreConfig;

const getEquipmentData = async ({ equipmentId }) => {
    const response = await axiosBase({
        method: apiConfig.reqMethod.GET,
        api: apiConfig.endpoints.equipment + "/" + equipmentId
    });
    return response.data.data;
};

const getBaseSaveData = async ({ equipmentScopeId }) => {
    const response = await axiosBase({
        method: apiConfig.reqMethod.GET,
        api: apiConfig.endpoints.equipmentScope + "/" + equipmentScopeId
    });
    const scopeData = response.data.data;
    return {
        MaxScopesPerBasin: scopeData.MaxScopesPerBasin,
        ScopesPerBasin: 1
    };
};

export const setDynamicColumnAndBaseData = async ({ defaultConfig, setState, equipmentScopeId, equipmentId, formName }) => {
    try {
        const equipmentData = await getEquipmentData({ equipmentId });
        const validationField = formName === hookupConfig ? 'HookupConfigValuesValidations' : 'ParameterSetsValuesValidations';
        const dynamicColumns = equipmentData[validationField] || '[]';
        const baseData = await getBaseSaveData({ equipmentScopeId });
        const newColumns = JSON.parse(dynamicColumns);
        newColumns.forEach(column => {
            column.label = column.field;
            column.field = `dynamic-${column.field}`;
        });
        // setting region as non-required for Enspire equipment
        if (Number(equipmentData.EquipmentId) === equipmentIdMapper.Enspire3000) {
            const regionColumn = defaultConfig.columns.find(col => col.field === 'RegionId');
            regionColumn && (regionColumn.required = false);
        }
        const extendedConfig = {
            ...defaultConfig,
            columns: [...defaultConfig.columns, ...newColumns]
        };
        setState((prev) => ({ ...prev, formConfig: extendedConfig, baseData }));
    } catch (error) {
        logger({ message: `Error while setting the dynamic columns: ${error}`, error });
    }
};

function ParameterSetForm() {
    const { equipmentId, equipmentScopeId } = useParams();
    const [state, setState] = useState({ formConfig: null, baseData: {} });
    useEffect(() => {
        if (!equipmentId || !equipmentScopeId) return;
        const deepCopiedConfig = { ...defaultConfig, columns: [...defaultConfig.columns.map(col => ({ ...col }))] };
        setDynamicColumnAndBaseData({ defaultConfig: deepCopiedConfig, setState, equipmentScopeId, equipmentId, formName: "Parameter" });
        getBaseSaveData({ equipmentScopeId });
    }, [equipmentId, equipmentScopeId]);

    const ParameterForm = useMemo(() => {
        if (!state.formConfig) return null;
        return new CommonUiModel(state.formConfig);
    }, [state.formConfig]);

    if (!ParameterForm) return null;
    return (
        <Box>
            <ParameterForm.Form
                baseSaveData={{ EquipmentScopeId: parseInt(equipmentScopeId), ...state.baseData }}
            />
        </Box>
    );
}

export default ParameterSetForm;
